module.exports = __webpack_public_path__ + "static/media/grabalo-icon.6e2b4267.png";